var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene-wrapper"},[(_vm.loaderOpen)?_c('HeadLoader',{attrs:{"isLoading":_vm.isLoading},on:{"continue":function($event){_vm.loaderOpen = false}}}):_vm._e(),_c('div',{ref:"sceneContainer",staticClass:"scene-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }